export const SHOPIFY_BACKEND_URL = 'https://api.wafaudio.com';